import { createNode } from '@glueapp/graph-types';
import { TodoistIntegration } from './TodoistIntegration';

export const AddTodoistTask = createNode({
    id: 'Add Todoist Task',
    name: 'Add Todoist Task',
    description: 'Add a task in Todoist',
    aiDescription:
        'Requires the Todoist integration to be connected. Takes a "Task Name" (string) input port for the task content, an optional "Due Date" (string) for natural language due dates, a "Priority" input port accepting "None", "Low", "Medium", or "High", and an optional "Project" (string) input port. Produces no data outputs.',
    category: 'Todoist',
    color: '#e44232',
    integration: TodoistIntegration,
    isAsync: true,
    inPorts: {
        'Task Name': { kind: 'string' },
        'Due Date': { kind: 'string' },
        Priority: {
            kind: 'union',
            subTypes: [
                { kind: 'stringLiteral', stringLiteral: 'None' },
                { kind: 'stringLiteral', stringLiteral: 'Low' },
                { kind: 'stringLiteral', stringLiteral: 'Medium' },
                { kind: 'stringLiteral', stringLiteral: 'High' },
            ],
        },
        Project: { kind: 'string' },
    },
    outPorts: {},
    execute: async function (input) {
        const taskName = input.inPorts['Task Name'];
        const dueDate = input.inPorts['Due Date'];
        const priority = input.inPorts.Priority;

        let priorityNumber = 1;
        switch (priority) {
            case 'None':
                priorityNumber = 1;
                break;
            case 'Low':
                priorityNumber = 2;
                break;
            case 'Medium':
                priorityNumber = 3;
                break;
            case 'High':
                priorityNumber = 4;
                break;
        }

        try {
            await input.integration.callIntegration({
                url: 'https://api.todoist.com/rest/v1/tasks',
                method: 'POST',
                data: {
                    content: taskName,
                    due_string: dueDate,
                    due_lang: 'en',
                    priority: priorityNumber,
                },
            });
            return { output: { output: {} } };
        } catch {
            return { output: { output: {} } };
        }
    },
});
